// Cell helpers and file naming shared by the Excel exports (courts and Beauty). The sheets are plain arrays
// (no xlsx import here) so the workbook content stays unit-testable; the download lives in statsExport.js.
//
// Cells are numbers with an Excel number format (not pre-formatted text), so the owner can sort, sum and
// chart them. A value the back could not compute (null) is an empty cell, never a 0.

const FMT_PCT = "0.0%";
const FMT_INT = "#,##0";
const FMT_HOURS = "#,##0.0";
const FMT_MONEY = '"$" #,##0';

const num = (value, z) => (typeof value === "number" && Number.isFinite(value) ? { t: "n", v: value, z } : "");
export const pct = (value) => num(value, FMT_PCT);
export const int = (value) => num(value, FMT_INT);
export const hours = (value) => num(value, FMT_HOURS);
export const money = (value) => num(value, FMT_MONEY);

/** "2026-09-13 a 2026-10-12" */
export const rangeText = ({ from, to }) => `${from} a ${to}`;

/**
 * Row of an indicator table: the label, the value now and, when there is a comparison period, the value then.
 * @param {boolean} withComparison  whether the table has a comparison column
 */
export const indicatorRow = (label, format, now, then, withComparison) => {
  const row = [label, format(now)];
  if (withComparison) row.push(format(then));
  return row;
};

/**
 * Download name: a prefix, the entity name in a filesystem-safe slug (accents and symbols removed) and the
 * period. `fallback` replaces a name with nothing usable.
 */
export const statsFileNameFor = ({ prefix, name, fallback, from, to }) => {
  const slug = String(name || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
  return `${prefix}_${slug || fallback}_${from}_${to}.xlsx`;
};
